// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3R94a","tabs":"style_tabs__3Hjat","item":"style_item__3Rc5p","active":"style_active__q4CGO","box":"style_box__2YpDs"};